export const SYSTEM_USERNAME = 'system';
export const API_KEY_SUFFIX = '_api_key';
export const EVERYONE_USERGROUP = 'Everyone';
export const AGENTS_USERGROUP = 'Agents';

// Tab indexes for sorting
export const DATASOURCES_PARENT_TAB_INDEX = 0;
export const USER_MANAGEMENT_TAB_INDEX = 1;
export const SYSTEM_ACTIVITY_TAB_INDEX = 2;
export const CONFIGURATION_TAB_INDEX = 3;
export const PLUGINS_TAB_INDEX = 4;

// Datasource tab child tab indexes
export const DATASOURCES_TAB_INDEX = 0;
export const AGENTS_TAB_INDEX = 1;

// User management tab child tab indexes
export const USERS_TAB_INDEX = 0;
export const GROUPS_TAB_INDEX = 1;
export const CAPABILITIES_TAB_INDEX = 2;
export const ACCESS_KEYS_TAB_INDEX = 3;

// System activity tab child tab indexes
export const SCHEDULES_TAB_INDEX = 0;
export const JOBS_TAB_INDEX = 1;
export const REQUESTS_TAB_INDEX = 2;
export const EXPORTS_TAB_INDEX = 3;
export const USAGE_TAB_INDEX = 4;
export const SUBSCRIPTIONS_TAB_INDEX = 5;

export const SCHEDULABLE_TABLE_CANCELLATION_GROUP = 'schedulableAdminTable';
export const SCHEDULABLE_CHARTS_CANCELLATION_GROUP = 'schedulableAdminChart';

/**
 * Needs to be high enough to get all on busy servers, but not so high it causes OOM or frontend performance. 10k is a
 * good balance that has been tested.
 */
export const ADMIN_LIMIT = 10000;

// Tab IDs
export const USERS_TAB_ID = 'usersTab';
export const GROUPS_TAB_ID = 'groupsTab';
export const CAPABILITIES_TAB_ID = 'capabilitiesTab';
export const ACCESS_KEYS_TAB_ID = 'accessKeyTab';
export const REQUESTS_TAB_ID = 'requestsTab';
export const SUBSCRIPTIONS_TAB_ID = 'subscriptionsTab';
export const JOBS_TAB_ID = 'jobsTab';
export const DATASOURCES_TAB_ID = 'datasourcesTab';
export const AGENTS_TAB_ID = 'agentsTab';
export const SCHEDULES_TAB_ID = 'schedulesTab';
export const USAGE_TAB_ID = 'usageTab';
export const EXPORTS_TAB_ID = 'exportsTab';
export const CONFIGURATION_TAB_ID = 'configurationTab';
export const PLUGINS_TAB_ID = 'pluginsTab';
export const SYSTEM_ACTIVITY_TAB_ID = 'systemActivityTab';
export const USER_MANAGEMENT_TAB_ID = 'userManagementTab';
export const DATASOURCES_TAB_PARENT_ID = 'datasourceAdministrationTab';
